<template>
  <b-container fluid>
    <div v-if="showoverlay" style="z-index: 999; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
      <b-spinner style="width: 3rem; height: 3rem;" label="Please wait..."></b-spinner>
    </div>
    <b-overlay class="overspin" :show="showoverlay" rounded="sm" fixed>
      <!-- <b-row cols="2" style="width:50rem;" class="m-2"> -->
      <b-row class="pt-2">
        <b-col sm="1">
          <label for="trans-needtip">Tips</label>
          <b-form-checkbox id="trans-needtip" v-model="needtip" switch size="lg" @input="fetchTipsOnly()"></b-form-checkbox>
        </b-col>
        <b-col sm="3">
          <label for="trans-date-from">Date From</label>
          <b-form-datepicker id="trans-date-from" v-model="datefrom"></b-form-datepicker>
        </b-col>
        <b-col sm="3">
          <label for="trans-date-to">Date To</label>
          <b-form-datepicker id="trans-date-to" v-model="dateto"></b-form-datepicker>
        </b-col>
        <b-col sm="2">
          <label for="trans-ordnum">Order #</label>
          <b-form-input id="trans-ordnum" v-model="ordnum"></b-form-input>
        </b-col>
        <b-col sm="3">
          <label for="trans-custname">Customer</label>
          <b-form-input id="trans-custname" v-model="custname"></b-form-input>
        </b-col>
      </b-row>

      <b-row class="py-2">
        <b-col cols="6" sm="3" lg="2"><b-button class="px-5" variant="light" @click="clearFilters">Clear</b-button></b-col>
        <b-col cols="6" lg="2"><b-button class="px-5" variant="dark" @click="fetchTransactions()">Filter</b-button></b-col>
        <b-col cols="12" lg="4" class="pt-2 pt-lg-0"><b-pagination v-if="total_trans>limit" v-model="currentPage" :total-rows="total_trans" :per-page="limit" align="center" @change="changePage()"></b-pagination></b-col>
        <b-col class="d-none d-lg-block" cols="4"></b-col>
      </b-row>

        <b-list-group>
          <b-list-group-item class="d-none d-xl-block">
            <b-row>
              <b-col cols="1"><b>Trans Date</b></b-col>
              <b-col cols="1"><b>Order #</b></b-col>
              <b-col cols="2"><b>Cust Name</b></b-col>
              <b-col cols="3"><b>Trans #</b></b-col>
              <b-col cols="1"><b>Amount</b></b-col>
              <b-col cols="1"><b>Receipt</b></b-col>
              <b-col cols="1"><b>Tip</b></b-col>
              <b-col cols="1"><b>Refund</b></b-col>
              <b-col cols="1"><b>Payment Type</b></b-col>
            </b-row>
          </b-list-group-item>
          <b-list-group-item class="d-xl-none">
            <b-row>
              <b-col cols="3"><b>Trans Date</b></b-col>
              <b-col cols="5"><b>Order #</b></b-col>
              <b-col cols="2"><b>Amount</b></b-col>
              <b-col cols="2"><b>Tip</b></b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
        <b-list-group>
          <TransactionInfo
            v-for="transaction in transactions"
            :key="transaction.id"
            :transaction="transaction"
            @emit-fetch-transactions="fetchTransactions"
            @emit-spinner="showoverlay=true">
          </TransactionInfo>
        </b-list-group>
        <b-row class="pt-3">
          <b-col cols="1"></b-col>
          <b-col cols="3">
            Number of transactions: {{ total_trans }}
          </b-col>
          <b-col cols="3">
            Average transaction: {{ avg_amnt | toCurrency }}
          </b-col>
          <b-col cols="3">
            Total transaction amount: {{ total_amnt | toCurrency }}
          </b-col>
        </b-row>
      <b-pagination v-if="total_trans>limit" v-model="currentPage" :total-rows="total_trans" :per-page="limit" align="center" @change="changePage()"></b-pagination>
    </b-overlay>
  </b-container>
</template>


<script>
import TransactionInfo from '@/components/TransactionInfo.vue'

export default {
  name: "Transactions",
  components: {
    TransactionInfo
  },
  data() {
    return {
      transactions: [],
      current_location: 0,
      limit: 25,
      currentPage: 1,
      showoverlay: false,
      datefrom: '',
      dateto: '',
      sortparams: '',
      total_trans: 0,
      total_amnt: 0,
      avg_amnt: 0,
      needtip: false,
      ordnum: '',
      custname: ''
    };
  },

  computed: {
    // all pagination, filtering and sorting info collected here for housekeeping purposes
    urlext: function() {
      const datefrom = this.datefrom == '' && this.ordnum == '' && this.custname == '' && this.needtip==false ?  '&datefrom=gte:'+this.today : this.datefromfilter;
      return "?page="+this.currentPage+"&limit="+this.limit+datefrom+this.datetofilter+this.ordnumfilter+this.custnamefilter+this.needtipfilter;
    },

    today: function() {
      var d = new Date();
      return d.toISOString().substr(0,10);
    },

    ordnumfilter: function() {
      if (this.ordnum) {
        return '&ordnum=like:'+this.ordnum;
      } else {
        return '';
      }
    },

    datefromfilter: function() {
      if (this.datefrom) {
        return '&datefrom=gte:'+this.datefrom;
      } else {
        return '';
      }
    },

    datetofilter: function() {
      if (this.dateto) {
        return '&dateto=lte:'+this.dateto;
      } else {
        return '';
      }
    },

    custnamefilter: function() {
      if (this.custname) {
        return '&custname=like:'+this.custname;
      } else {
        return '';
      }
    },

    needtipfilter: function() {
      if (this.needtip) {
        return '&needtip=True';
      } else {
        return '';
      }
    }

  },

  methods: {
    fetchTipsOnly() {
      // clear other filters and return only transactions which need tips
      this.clearFilters();
      this.fetchTransactions();
    },

    async fetchLocations() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("locations", {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      const locations = await data.locations;
      const sortedlocations = await locations.sort((a,b) => a.id - b.id);
      this.current_location = await sortedlocations[0].id;

      this.fetchTransactions()
    },

    async fetchTransactions() {
      this.showoverlay = true;
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("locations/"+this.current_location+"/transactions"+this.urlext, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      this.transactions = data.transactions;
      this.total_trans = data.total_number_transactions;
      this.total_amnt = data.transaction_total_amount;
      this.avg_amnt = data.transaction_avg_amount;
      this.showoverlay = false;
    },

    changePage() {
      this.showoverlay = true;
      this.fetchTransactions();
    },

    clearFilters() {
      this.datefrom= '';
      this.dateto='';
      this.ordnum='';
      this.custname='';
    },

  },

  created: function() {
    this.showoverlay = true;
    this.fetchLocations();
  },

};
</script>
<style>
  .overspin .spinner-border {
    visibility: hidden;
  }

</style>
